import React from 'react';
import ActionsYouCanTake from 'partial/OfferManager/modules/NotificationAlertsDetails/components/ActionsYouCanTake/ActionsYouCanTake';
import {
  CREDIT_CARD_VERTICAL,
  AUTO_LOAN_VERTICAL,
  PERSONAL_LOAN_VERTICAL,
} from 'types/mrph.vertical.constants';

const improvedScoreChangeCopies = [
  {
    title: 'Is it time to apply for a credit card?',
    subtitle: 'You may qualify for a reward card based on your new score band.',
    takeAction: {
      module: 'PL_PQ_OFFERS',
      title: 'Rewards cards',
      icon: 'exploreRewardsCardsIcon',
      link: '/offers/creditcard?creditCardType=REWARDS',
      vertical: CREDIT_CARD_VERTICAL,
      clickTile: 'Rewards cards',
    },
  },

  {
    title: 'Can you get a better auto loan rate?',
    subtitle:
      'You may qualify for a better auto loan interest rate based on your new score band.',
    takeAction: {
      module: 'PL_PQ_OFFERS',
      title: 'Auto loans',
      icon: 'exploreAutoLoans',
      link: '/offers?vertical=AUTO_LOAN',
      vertical: AUTO_LOAN_VERTICAL,
      clickTile: 'Auto loans',
    },
  },
  {
    title: 'Do you need a personal loan?',
    subtitle:
      'You may qualify for a personal loan based on your new score band.',
    takeAction: {
      module: 'DEBT_RELIEF',
      title: 'Explore personal loans',
      icon: 'explorePersonalLoansIcon',
      link: '/offers?vertical=PERSONAL_LOAN',
      vertical: PERSONAL_LOAN_VERTICAL,
      clickTile: 'Explore personal loans',
    },
  },
];

const ActionYouCanTakeWrapper = props => {
  const { isScoreBandImproved, config } = props;
  let actionsYouCanTake = improvedScoreChangeCopies;
  let title = 'Credit options to consider';
  let subtitle =
    'Moving up a credit score band can result in better loan rates, access to more credit and potential savings on interest payments.';
  if (!isScoreBandImproved) {
    actionsYouCanTake =
      config?.notificationAlerts?.accountChangeScoreBand?.steps;
    title =
      config?.notificationAlerts?.accountChangeScoreBand?.actionYouCanTake
        ?.title;
    subtitle =
      config?.notificationAlerts?.accountChangeScoreBand?.actionYouCanTake
        ?.description;
  }

  return (
    <ActionsYouCanTake
      {...props}
      title={title}
      subTitle={subtitle}
      actionsYouCanTake={actionsYouCanTake}
    />
  );
};

export default ActionYouCanTakeWrapper;
